const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Flex+Office+Domain+Assets/";

export const FLEX_DOMAIN = {

    IMAGES: {
        IMAGE_1: `${BASE_URL}image2.jpeg`,
        IMAGE_2: `${BASE_URL}image28.jpeg`,
        IMAGE_3: `${BASE_URL}image3.jpeg`,
        IMAGE_8: `${BASE_URL}image8.jpeg`,
        IMAGE_4: `${BASE_URL}contact.png`,
        IMAGE_5: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=85&fit=crop&auto=format",
        IMAGE_6: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&q=85&fit=crop&auto=format",
        IMAGE_7: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=85&fit=crop&auto=format",

    },
};
